import { axios } from "@/utils"

export default {
    getCart(params) {
        return axios.get('/v1/cart/', { params: params })
    },

    confirmPayment(transactionId, paymentMethod, extraData) {
        return axios.post(`/v3/orders/confirm-payment/`,  {
            transaction_id: transactionId,
            payment_method: paymentMethod,
            extra_data: extraData
        })
    },

    getCountries() {
        return axios.get(`/v1/countries/`)
    }
}
